import { ToastManager, TopLoadingBar } from '@aus-platform/design-system';
import { MsalProvider } from '@azure/msal-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { store } from 'app/store';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { initializeAnalytics } from 'shared/analytics';
import { queryClient } from 'shared/api';
import { history } from 'shared/constants';
import { CustomRouter } from 'shared/routes';
import { App } from './app';
import { msalInstance } from './auth';
import { setupSentry } from './config';
import ErrorBoundary from './error-boundary';

const Root = () => {
  return (
    <>
      <ToastManager />
      <TopLoadingBar />
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <CustomRouter history={history}>
            <ErrorBoundary>
              <MsalProvider instance={msalInstance}>
                <App />
              </MsalProvider>
            </ErrorBoundary>
          </CustomRouter>
        </Provider>
        <div
          style={{
            fontSize: '20px',
            // Comment the below line to use React Query Dev Tools.
            display: 'none',
          }}
        >
          <ReactQueryDevtools initialIsOpen={false} />
        </div>
      </QueryClientProvider>
    </>
  );
};

export default Root;

const container = document.getElementById('root');

initializeAnalytics();

if (container) {
  const root = createRoot(container); // createRoot(container!) if you use TypeScript
  root.render(<Root />);
}

setupSentry();
